import React, { useLayoutEffect, useRef, useState } from "react"
import { i18n } from "@/i18n"
import { Modal } from "@/components/Modal"
import { Close } from "@/components/Close"
import styles from "./index.module.scss"
import cls from "classnames"

interface RewardRuleProps {
    open: boolean
    onClose: () => void
    showConfirmBtn?: boolean
    confirmText?: string
    onConfirm?: () => void
}

const RewardRule: React.FC<RewardRuleProps> = ({
    open,
    onClose,
    showConfirmBtn = false,
    confirmText,
    onConfirm,
}) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [isAtBottom, setIsAtBottom] = useState(false)

    useLayoutEffect(() => {
        if (!open) {
            setIsAtBottom(false)
            return
        }

        const container = containerRef.current
        if (!container) {
            // 如果容器还没有准备好，使用 requestAnimationFrame 延迟检查
            const rafId = requestAnimationFrame(() => {
                const delayedContainer = containerRef.current
                if (delayedContainer) {
                    const handleScroll = () => {
                        const { scrollTop, scrollHeight, clientHeight } =
                            delayedContainer
                        // 判断是否滚动到底部（允许 1px 的误差）
                        const atBottom =
                            scrollHeight - scrollTop - clientHeight <= 1
                        setIsAtBottom(atBottom)
                    }

                    delayedContainer.addEventListener("scroll", handleScroll)
                    // 初始检查
                    handleScroll()
                }
            })

            return () => {
                cancelAnimationFrame(rafId)
            }
        }

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = container
            // 判断是否滚动到底部（允许 1px 的误差）
            const atBottom = scrollHeight - scrollTop - clientHeight <= 1
            setIsAtBottom(atBottom)
        }

        container.addEventListener("scroll", handleScroll)
        // 初始检查
        handleScroll()

        return () => {
            container.removeEventListener("scroll", handleScroll)
        }
    }, [open])

    return (
        <Modal
            showCloseBtn={false}
            modalClass={styles.ruleModal}
            open={open}
            onClose={onClose}
            showConfirmBtn={showConfirmBtn}
            confirmText={confirmText}
            onConfirm={onConfirm}
            maskClass={styles.ruleModalMask}
        >
            <div
                ref={containerRef}
                className={cls(styles.ruleContainer, {
                    [styles.noMask]: isAtBottom,
                })}
            >
                <div className={styles.textContainer}>
                    <div className={styles.section}>
                        {i18n.get("rule.text_lottery_rule")}
                    </div>
                    {i18n.getArray("rule.rules", "main").map((item, index) => {
                        return (
                            <div className={styles.ruleItem} key={item}>
                                <div className={styles.label}>0{index + 1}</div>
                                <div
                                    className={styles.text}
                                    // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></div>
                            </div>
                        )
                    })}
                    <div className={styles.section}>
                        {i18n.get("rule.title_special_instructions")}
                    </div>
                    {i18n
                        .getArray("rule.special_instructions", "main")
                        .map((item, index) => {
                            return (
                                <div className={styles.ruleItem} key={item}>
                                    <div className={styles.label}>
                                        0{index + 1}
                                    </div>
                                    <div
                                        className={styles.text}
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    ></div>
                                </div>
                            )
                        })}
                    <div className={styles.section}>
                        {i18n.get("rule.title_remind")}
                    </div>
                    {i18n.getArray("rule.remind", "main").map((item, index) => {
                        return (
                            <div className={styles.ruleItem} key={item}>
                                <div className={styles.label}>0{index + 1}</div>
                                <div
                                    className={styles.text}
                                    // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></div>
                            </div>
                        )
                    })}
                </div>
                <div className={styles.filter}></div>
            </div>
            <Close
                onClose={(e) => {
                    e.stopPropagation()
                    onClose()
                }}
            />
        </Modal>
    )
}

export default RewardRule
